// Colors failures red and warnings amber so they stand out in a long log (uppercase keywords only,
// so the lowercase "failed: 0" / "warning: 0" summary lines stay neutral).
function logLineClass(line) {
  if (/\bFAILED\b/.test(line)) return 'demo-env-mgmt-log-line-error';
  if (/\bWARNING\b/.test(line)) return 'demo-env-mgmt-log-line-warn';
  return undefined;
}

function RunSection({
  action,
  plan,
  running,
  onRunList,
  onPreview,
  onConfirm,
  onCancelPlan,
  runError,
  log,
  canListSource,
  onRunSourceList,
  sourceRun,
  resolvedSourceDatasourceId,
  resolvedTargetDatasourceId,
}) {
  return (
    <div className="demo-env-mgmt-section">
      <h2 className="demo-env-mgmt-section-title">Run</h2>

      <div className="demo-env-mgmt-columns">
        {/* Source — always just a List button, wholly independent of whatever action is selected for Target */}
        <div className="demo-env-mgmt-column">
          <h3 className="demo-env-mgmt-column-title">
            Source{Number.isFinite(resolvedSourceDatasourceId) && resolvedSourceDatasourceId > 0 ? ` (${resolvedSourceDatasourceId})` : ''}
          </h3>
          <div className="demo-env-mgmt-actions" style={{ marginTop: 0 }}>
            <button className="demo-env-mgmt-btn" type="button" onClick={onRunSourceList} disabled={!canListSource}>
              Run list
            </button>
          </div>
          {!canListSource && (
            <p className="demo-env-mgmt-label" style={{ marginTop: 6 }}>Not available for the composite &quot;All entity types&quot; — see Action above.</p>
          )}
          {sourceRun.error && <p className="demo-env-mgmt-error">{sourceRun.error}</p>}
          {sourceRun.lines.length > 0 && (
            <div className="demo-env-mgmt-log" style={{ marginTop: 6 }}>
              {sourceRun.lines.map((line, i) => (
                <div key={i}>{line}</div>
              ))}
            </div>
          )}
        </div>

        {/* Target — runs whatever action is currently selected (List/Create/Delete/Resync) */}
        <div className="demo-env-mgmt-column">
          <h3 className="demo-env-mgmt-column-title">
            Target{Number.isFinite(resolvedTargetDatasourceId) && resolvedTargetDatasourceId > 0 ? ` (${resolvedTargetDatasourceId})` : ''}
          </h3>
          <div className="demo-env-mgmt-actions" style={{ marginTop: 0 }}>
            {action === 'list' ? (
              <button className="demo-env-mgmt-btn" type="button" onClick={onRunList} disabled={running}>
                {running ? 'Running…' : 'Run list'}
              </button>
            ) : !plan ? (
              <button className="demo-env-mgmt-btn" type="button" onClick={onPreview} disabled={running}>
                {running ? 'Preparing…' : 'Preview'}
              </button>
            ) : (
              <>
                <button
                  className={`demo-env-mgmt-btn${action === 'delete' ? ' demo-env-mgmt-btn-danger' : ''}`}
                  type="button"
                  onClick={onConfirm}
                  disabled={running}
                >
                  {running ? 'Running…' : 'Confirm'}
                </button>
                <button
                  className="demo-env-mgmt-btn demo-env-mgmt-btn-secondary"
                  type="button"
                  onClick={onCancelPlan}
                  disabled={running}
                >
                  Cancel
                </button>
              </>
            )}
          </div>

          {plan && (
            <p className="demo-env-mgmt-label" style={{ marginTop: 6 }}>
              <span className="demo-env-mgmt-badge demo-env-mgmt-badge-dry-run">Dry run</span>{' '}
              Review the log below, then Confirm to actually {action}.
            </p>
          )}

          {runError && <p className="demo-env-mgmt-error">{runError}</p>}

          {log.length > 0 && (
            <div className="demo-env-mgmt-log" style={{ marginTop: 6 }}>
              {log.map((line, i) => (
                <div key={i} className={logLineClass(line)}>{line}</div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default RunSection;
